import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
    return (
        <a
            href="https://wa.me/256700000000"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed left-5 bottom-5 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
            data-testid="whatsapp-floating-btn"
            aria-label="Chat on WhatsApp"
        >
            <MessageCircle className="w-7 h-7" fill="white" stroke="none" />
        </a>
    );
}
